/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilIcon20Solid = forwardRef('ToolPencilIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 16.5v-2.086a1 1 0 0 1 .293-.707l8.145-8.145 3 3-8.145 8.145a1 1 0 0 1-.707.293H3.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "m15.51 7.49 1.07-1.07a1.3 1.3 0 0 0 0-1.84l-1.16-1.16a1.3 1.3 0 0 0-1.84 0l-1.07 1.07 3 3Z" })));
});
